import { render, staticRenderFns } from "./SpectatorVideo.vue?vue&type=template&id=5006fe90&scoped=true&"
import script from "./SpectatorVideo.vue?vue&type=script&lang=js&"
export * from "./SpectatorVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5006fe90",
  null
  
)

export default component.exports